<template>
  <v-dialog
    :model-value="props.shouldShowProgressDialog"
    :width="500"
    persistent
    scrollable
    transition="fade">
    <v-card class="dialog-box" :width="500">
      <v-card-title v-if="title" class="text-center">{{ title }}</v-card-title>
      <v-card-text class="px-8 pb-6 pt-2">
        <v-container fluid>
          <transition name="slide-fade" mode="out-in">
            <div class="font-size-large text-center mb-6" :key="props.currentStepMessage">
              {{ props.currentStepMessage }}
            </div>
          </transition>

          <v-progress-linear
            :model-value="props.currentPerc"
            stream
            buffer-value="0"
            color="info"
            height="25">
            <template v-slot:default="{ value }">
              <strong>{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>
          <div class="text-center font-size-x-small mt-4 font-italic">
            This may take a moment, please be patient!
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
/* global defineProps */

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: ''
  },
  shouldShowProgressDialog: {
    type: Boolean,
    required: false,
    default: false
  },
  currentStepMessage: {
    type: String,
    required: false,
    default: ''
  },
  currentPerc: {
    type: Number,
    required: false,
    default: 0
  }
});
</script>
